// removed by extract-text-webpack-plugin
module.exports = {"loaderContainer":"_3djMk","arcsContainer":"_2WLvm","darkArc":"PxmiM","lightArc":"_3oXGn","text":"ZdUjb","small":"_1tv_t","rotation":"_10GqU","medium":"KOeB4","large":"_3fIwl","staggered-rotation":"GTqNK","staggeredRotation":"GTqNK","blue":"_3HCSv","white":"_1drU-"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-style-react/dist/src/Loader/Loader.scss
// module id = 140
// module chunks = 0 1